<template>
    <!-- 分配子账号弹窗 -->
    <div v-if="userInfo.isShow">
	    <div class="mask allot-child-accont user-center-modal">
	        <div class="e-modal small">
	            <div class="e-modal-title">Subaccount management <i class="e-modal-close" @click="userInfo.isShow=false"></i></div>
	            <div class="e-modal-body">
	                <div class="e-form">
	                    <div class="form-contorl">
	                        <label class="title">Name：</label>
	                        <input type="text" v-model="Name" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">Password：</label>
	                        <input type="password" v-model="Pwd" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">Confirm password：</label>
	                        <input type="password" v-model="Pwd2" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">Phone：</label>
	                        <input type="text" v-model="Phone" />
	                    </div>
	                    <div class="form-contorl">
	                        <label class="title">Fax：</label>
	                        <input type="text" v-model="Fax" />
	                    </div>
	                </div>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="create">save</div>
	                <div class="long-btn cancel-btn" @click="userInfo.isShow=false">cancel</div>
	            </div>
	        </div>
	    </div>
	</div>
	
</template>
<script>
	export default{
		name:'AllotChildAccont',
		props:{
			userInfo:{
				type:Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return{
				Name:'',
				Pwd:'',
				Pwd2:'',
				Phone:'',
				Fax:''
			}
		},
		methods:{
			create(){
				var that=this;
				if(!that.Name){
		            that.error({title: 'Create error',content: 'Please enter name'})
            		return;
				}
				if(!that.Pwd){
		            that.error({title: 'Create error',content: 'Please enter password'})
            		return;
				}
				if(that.Pwd.length<6||that.Pwd.length>32){
		            that.error({title: 'Create error',content: 'The password contains a minimum of 6 characters and a maximum of 32 characters'})
            		return;
				}

				if(!that.Pwd2){
		            that.error({title: 'Create error',content: 'Please enter confirmation password'})
            		return;
				}

				if(that.Pwd!=that.Pwd2){
		            that.error({title: 'Create error',content: 'The password is different from the confirm password'})
            		return;
				}


				if(!that.Phone){
		            that.error({title: 'Create error',content: 'Please enter phone number'})
            		return;
				}
				if(!that.Fax){
		            that.error({title: 'Create error',content: 'Please enter fax'})
            		return;
				}
				var params={
					Name:this.Name,
					Pwd:this.Pwd,
					Pwd2:this.Pwd2,
					Phone:this.Phone,
					Fax:this.Fax
				}
				that.postRequest({
	                url: that.Api.createSubUser,
	                params: params
	            }).then(res => {
	                if (res&&res.IsSuccess) {
	                	that.error({ title: 'Tips', content: 'Created successfully' });
	                	that.userInfo.isShow=false;
	                	that.$emit('done')
	                   
	                } else {
	                    that.error({ title: 'Tips', content: 'Error creating, please try again' });
	                }
	            });

			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/user/AllotChildAccont.vue